import React from 'react';
import { Menu, MenuItem, Typography, CircularProgress, Box, Divider } from '@mui/material';

interface PopupMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  items?: Array<{
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  }>;
  width?: number | string;
  children?: React.ReactNode; // custom content inside menu
}

const PopupMenu: React.FC<PopupMenuProps> = ({
  anchorEl,
  open,
  onClose,
  loading = false,
  items = [],
  width = 250,
  children,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      MenuListProps={{
        sx: { width },
      }}
    >
      {/* Loader */}
      {loading && (
        <MenuItem disableRipple>
          <CircularProgress size={20} />
        </MenuItem>
      )}

      {children}
      {items?.length > 0 && !loading ? (
        <Typography sx={{ px: 2, py: 1, fontWeight: 'bold' }}>Select Type to Start</Typography>
      ) : !loading ? (
        <Typography sx={{ px: 2, py: 1, fontWeight: 'bold' }}>No Groups</Typography>
      ) : null}
      <Divider />
      {!loading &&
        items?.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              item.onClick();
              onClose(); // close after click
            }}
            sx={{ '&:hover': { backgroundColor: '#c2bebeff' } }}
          >
            <Typography sx={{ flexGrow: 1, color: 'blue' }}>{item.label}</Typography>
            {item.icon && <Box ml={1}>{item.icon}</Box>}
          </MenuItem>
        ))}
    </Menu>
  );
};

export default PopupMenu;
